import { useDidName } from "../did/useDidName";
import { shortDid } from "../util";

/** A DID as people read it: its self-asserted name, always labelled as such, else the short DID.
 *  `name`: the rail's view field (display_name / holder_display_name, #93), which is
 *  authoritative where the view carries it (absent = no name); without it the label
 *  reads the DID's current document. */
export function DidLabel({ did, version, name: fromView }: { did: string; version?: number; name?: string | null }) {
  const fetched = useDidName(fromView === undefined ? did : undefined, version);
  const name = fromView === undefined ? fetched : fromView;
  if (!name) return <span className="mono" data-testid="did-short">{shortDid(did)}</span>;
  return (
    <span className="did-name" data-testid="did-name" title={did}>
      {name} · <span className="self-asserted" data-testid="self-asserted">self-asserted</span>
    </span>
  );
}
